class QuantitySelectorElement extends HTMLElement {
  connectedCallback() {
    if (!this.innerHTML.trim()) {
      this.innerHTML = `
        <button type="button" class="quantity-minus">-</button>
        <input type="number" min="0" value="0" step="1" class="quantity-value">
        <button type="button" class="quantity-plus">+</button>
      `;
    }

    this.input = this.querySelector('input[type="number"]');
    this.btnPlus = this.querySelector('.quantity-plus');
    this.btnMinus = this.querySelector('.quantity-minus');
    this.min = parseInt(this.input.getAttribute('min')) || 0;
    this.step = parseInt(this.input.getAttribute('step')) || 1;

    this.btnPlus?.removeEventListener('click', this._plusHandler);
    this.btnMinus?.removeEventListener('click', this._minusHandler);

    this._plusHandler = () => this.increase();
    this._minusHandler = () => this.decrease();

    this.btnPlus?.addEventListener('click', this._plusHandler);
    this.btnMinus?.addEventListener('click', this._minusHandler);

    this.input.addEventListener('input', () => {
      const variantId = this.getAttribute('data-variant-id');
      if (!variantId) return;

      const value = this.input.value;

      document.querySelectorAll(`quantity-selector-muti[data-variant-id="${variantId}"]`).forEach(selector => {
        if (selector === this) return; // bỏ qua chính nó
        const otherInput = selector.querySelector('input[type="number"]');
        if (otherInput && otherInput.value !== value) {
          otherInput.value = value;

          otherInput.dispatchEvent(new Event('input', { bubbles: true }));
          otherInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  increase() {
    const current = parseInt(this.input.value, 10) || 0;
    this.input.value = current + this.step;
    this.input.dispatchEvent(new Event('input', { bubbles: true }));
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
    updateTotalPrice();
    this.showImageFromSelector();
  }

  decrease() {
    const current = parseInt(this.input.value, 10) || 0;
    this.input.value = Math.max(this.min, current - this.step);
    this.input.dispatchEvent(new Event('input', { bubbles: true }));
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
    updateTotalPrice();
    this.showImageFromSelector();
  }

  showImageFromSelector() {
    
    const imageSrc = this.getAttribute('data-image-src');
    if (!imageSrc) return;

    const productMain = this.closest('.main_product');
    if (!productMain) return;

    // const galleryFigures = productMain.querySelectorAll('.product-gallery--media');

    // galleryFigures.forEach(figure => {
    //   figure.setAttribute('aria-hidden', 'true');
    //   figure.setAttribute('data-gallery-selected', 'false');
    // });

    // const matchingFigure = Array.from(galleryFigures).find(figure =>
    //   figure.getAttribute('data-image-src') === imageSrc
    // );

    // if (matchingFigure) {
    //   console.log("matchingFigure", matchingFigure)
    //   matchingFigure.setAttribute('aria-hidden', 'false');
    //   matchingFigure.setAttribute('data-gallery-selected', 'true');

    //   matchingFigure.scrollIntoView({ behavior: 'smooth', block: 'center' });
    // }
    const galleryThumbs = productMain.querySelectorAll('.product-gallery--media-thumbnail');

    const matchingThumb = Array.from(galleryThumbs).find(thumb =>
      thumb.getAttribute('data-image-src') === imageSrc
    );

    if (matchingThumb) {
      matchingThumb.click();
    }
  }

}

if (!customElements.get('quantity-selector-muti')) {
  customElements.define('quantity-selector-muti', QuantitySelectorElement);
}
